import type { Routes } from '@angular/router';

import { RoleGuard } from '#core/components/auth/role.guard';
import { AdminStore } from '#modules/admin/stores/admin.store';

export const ADMIN_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/admin/layouts/admin.component').then((m) => m.AdminComponent),
        canActivate: [RoleGuard],
        data: { roles: ['admin', 'accountManager'] },
        providers: [AdminStore],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'platforms-management',
            },
            {
                path: 'platforms-management',
                loadComponent: () =>
                    import('#modules/admin/views/platforms-management/platforms-management.component').then(
                        (m) => m.PlatformsManagementComponent
                    ),
                runGuardsAndResolvers: 'always',
            },
            {
                path: 'restaurants',
                loadComponent: () => import('#modules/admin/views/restaurants/restaurants.component').then((m) => m.RestaurantsComponent),
            },
            {
                path: 'platform-connections',
                loadComponent: () =>
                    import('#modules/admin/views/platform-connections/platform-connections.component').then(
                        (m) => m.PlatformConnectionsComponent
                    ),
                canActivate: [RoleGuard],
                data: { roles: ['admin'] },
            },
            {
                path: 'sending-insights',
                canActivate: [RoleGuard],
                data: { roles: ['admin'] },
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('#modules/admin/views/sending-insights/sending-insights.component').then(
                                (m) => m.SendingInsightsComponent
                            ),
                    },
                    {
                        path: 'organizations',
                        loadComponent: () =>
                            import('#modules/admin/views/organization-sending-insights/organization-sending-insights.component').then(
                                (m) => m.OrganizationSendingInsightsComponent
                            ),
                    },
                    {
                        path: 'organizations/:organizationId',
                        loadComponent: () =>
                            import('#modules/admin/views/organization-sending-insights/organization-sending-insights.component').then(
                                (m) => m.OrganizationSendingInsightsComponent
                            ),
                    },
                    {
                        path: 'campaigns/:campaignId',
                        loadComponent: () =>
                            import('#modules/admin/views/campaign-sending-insights/campaign-sending-insights.component').then(
                                (m) => m.CampaignSendingInsightsComponent
                            ),
                    },
                ],
            },
            {
                path: 'users',
                loadChildren: () => import('#modules/user/routes/admin-users.routes').then((m) => m.ADMIN_USERS_ROUTES),
            },
            {
                path: 'organizations',
                loadChildren: () =>
                    import('#modules/organization/routes/admin-organizations.routes').then((m) => m.ADMIN_ORGANIZATION_ROUTES),
            },
            {
                path: 'nfc',
                loadComponent: () => import('#modules/admin/views/nfc/nfc.component').then((m) => m.NfcComponent),
            },
            {
                path: 'api-keys',
                loadComponent: () => import('#modules/admin/views/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
                canActivate: [RoleGuard],
                data: { roles: ['admin'] },
            },
        ],
    },
];
